import { Permiso } from './../../../../_entities/Enums/permiso.enum';
import { SimService } from './../../services/sim.service';
import { SimVM } from './../../../../_entities/sims/SimVM';
import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
	selector: 'kt-sim',
	templateUrl: './sim.component.html',
	styleUrls: ['./sim.component.scss']
})

export class SimComponent implements OnInit {
	@ViewChild('gridContainer', { static: false }) gridContainer: ElementRef;
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

	public datosReporte = [];
	 isDisabled: boolean = true;

	public simsRegistros: SimVM[];
	public mensajeAgrupar: string = "Arrastre un encabezado de columna aquí para agrupar por esa columna"

	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public showNavigationButtons: boolean;
	public showPageSizeSelector: boolean;
	public currentFilter: any;

	public permisoConsultarSims: string;
	public permisoAgregarSim: string;
	public permisoActualizarSim: string;
	public permisoEliminarSim: string;

	constructor(private simService: SimService,
		private router: Router,
		private toastService: ToastrService) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.showNavigationButtons = true;
		this.showPageSizeSelector = true;
	}

	ngOnInit() {
		this.obtenerSims();
		this.obtenerPermisos();
	}

	obtenerSims() {
		this.simService.obtenerSims().subscribe(
			(response: SimVM[]) => {
				//this.simsRegistros = res;
				this.simsRegistros = response.map((x) => {
					if (x.nombreTelefonia == null || x.nombreTelefonia == '') {
						x.nombreTelefonia = 'Sin datos'
					}
					if (x.nombrePlanTarifario == null || x.nombrePlanTarifario == '') {
						x.nombrePlanTarifario = 'Sin datos'
					}

					let form = {
						'Sim': x.sim.toString(),
						'Número Telefónico': x.numeroTelefonico,
						'Telefonía': x.nombreTelefonia,
						'Plan Tarifario': x.nombrePlanTarifario,
						'Estatus': this.obtenerEstatus(x.estatus)
					}

					this.datosReporte.push(form);

					return {
						id: x.id,
						sim: x.sim,
						numeroTelefonico: x.numeroTelefonico,
						estatus: this.obtenerEstatus(x.estatus),
						idCliente: x.idCliente,
						nombreCliente: x.nombreCliente,
						idPLan: x.idPLan,
						nombrePlanTarifario: x.nombrePlanTarifario,
						idTelefonia: x.idTelefonia,
						nombreTelefonia: x.nombreTelefonia
					}
				});
				if(this.datosReporte.length > 0){
					this.isDisabled = false;
				}
			}, (error) => {
				this.toastService.error('ocurrio un error al obtener los sims');
			});
	}

	editarSim(simId) {
		this.router.navigateByUrl('/home/administracion/sims/sim/editar/' + simId);
	}

	eliminarSim(simId, sim) {
		Swal.fire({
			title: 'Eliminar',
			text: `¿Está seguro que desea eliminar el sim ${sim}?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then(
			(result) => {
				if (result.value) {
					this.simService.eliminarSims(simId).subscribe(
						(response) => {
							Swal.fire(
								'Eliminado!',
								'El sim ha sido eliminado.',
								'success'
							);
							this.obtenerSims();
						}, (error) => {
							Swal.fire(
								'Ops!',
								'Error al intentar eliminar el sim.',
								'error'
							);
						});
				}
			})
	}


	obtenerEstatus(estatus) {
		let estado = '';
		switch (estatus) {
			case 0:
				estado = 'Baja';
				break;
			case 1:
				estado = 'Disponible';
				break;
			case 2:
				estado = 'Asignado';
				break;
			case 3:
				estado = 'Revisión';
				break;
		}
		return estado;
	}

	public get Permiso() {
		return Permiso;
	}

	obtenerPermisos() {
		this.permisoConsultarSims = Permiso.ConsultarSims;
		this.permisoAgregarSim = Permiso.AgregarSim;
		this.permisoActualizarSim = Permiso.ActualizarSim;
		this.permisoEliminarSim = Permiso.EliminarSim;
	}

	public exportarExcel(){
		console.log("2 - Pretending to do stuff for two seconds");

		//this.enviarDatos.emit(this.simsRegistros)
	}

}
